import { registerBeginnerTimeBlocks as defineTimeBlocks } from './time-blocks.js';

let registered = false;

export function registerBeginnerTimeBlocks(): void {
  if (registered) {
    return;
  }
  defineTimeBlocks();
  registered = true;
}
